import QuickLinksSection from "./QuickLinksSection";
import ContactSection from "./ContactSection";
import FaqSection from "./FaqSection";
import { overviewFaqs } from "../data/faqs";

const ContactFaqSection = ({ source = "", content, contactSource }) => {
  return (
    <section>
      <div className="rounded-[10px] px-[12px] md:px-[24px]">
        <div className="bg-white rounded-[8px] p-0 md:p-[12px]">
          {/* Quick links tiles */}
          <QuickLinksSection contactSource={contactSource} />
          {contactSource === "AiSizing" && (
            <div className="flex flex-col text-center items-center justify-center mb-10">
              <div className="font-medium text-[16px] leading-[140%] tracking-normal">
                We want to reduce your returns, boost your sales, and make your
                customers happier with their purchases.
              </div>
              <div className="font-bold text-[16px] leading-[150%] tracking-normal text-center mt-[32px]">Amir Razipour</div>
              <div className="font-normal text-[13px] leading-[150%] tracking-normal text-center mt-1">CEO and Founder</div>
            </div>
          )}
          <div className="md:px-[65px]">
            <ContactSection content={content} />
          </div>
        </div>
        {/* FAQ block */}
        <FaqSection faqs={source === "SEO" ? undefined : overviewFaqs} />
      </div>
    </section>
  );
};

export default ContactFaqSection;
